import { getCalculatedText } from 'core';
import { Api } from 'lib';

/**
 * Controls fetch operations depending on
 * where the PostFeed component is used, including:
 *
 * Latest home feed: uses redux state,
 * User posts feed: uses component state,
 * Posts with hashtags: uses component state
 *
 */

async function fetchHome({ fetching, setFetching, dispatch, data }) {
  if (fetching) return;
  setFetching(true);

  const res = await Api.post('/home/fetchMore', {
    skip: data?.length || 0
  });

  if (!res) return setFetching(false);

  // Add read more previews to the captions
  const homePosts = await Promise.all(
    (res.posts || []).map(async (x) => ({
      ...x,
      calculatedText: await getCalculatedText(x.caption)
    }))
  );

  res.posts = homePosts;

  dispatch({
    type: 'ADD_POSTS',
    payload: res.posts
  });

  dispatch({
    type: 'ADD_POSTS_HOME',
    payload: res.posts
  });

  setFetching(false);
}

async function fetch({ id, fetching, setFetching, localData, setLocalData, setTitle, type }) {
  console.log('---------------------------------------------------------------------------------');
  console.log('fetching data');
  console.log('---------------------------------------------------------------------------------');
  if (localData.length) return;
  if (fetching) return;
  setFetching(true);
  const isUser = type === 'user';

  const res = await Api.post('/posts/get', {
    tag: isUser ? null : `#${id}`,
    userId: isUser ? id : null
  });

  console.log('---------------------------------------------------------------------------------');
  console.log('res', res);
  console.log('---------------------------------------------------------------------------------');

  if (!res) return setFetching(false);

  if (isUser) setTitle(res[0].owner.name);
  setFetching(false);
  setLocalData(res);
}

async function getData(props) {
  const { type } = props;

  switch (type) {
    case 'home':
      return await fetchHome(props);
    default:
      return await fetch(props);
  }
}

export default getData;
